import { ActionType, Action, facilityState } from "../actions/types"

const initialFacilityState: facilityState = {
  facility: {
    id: "",
    name: "",
    isGateLink: false
  }
}

const facilityReducer = (
  state: facilityState = initialFacilityState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_FACILITY:
      return {
        ...state,
        facility: action.payload
      }
    default:
      return state
  }
}

export default facilityReducer
